export const eventColors = [
  { bg: "rgb(37 85 239 / 11%)", text: "#2555EF" },
  { bg: "rgb(255 225 231 / 35%)", text: "#D2135C" },
  { bg: "rgb(255 242 226 / 30%)", text: "#D97706" },
  { bg: "rgb(229 248 237 / 54%)", text: "#1F9254" },
];

export const member_type_colors = [
  {
    color: "rgba(36, 85, 239,1)",
    background: "rgba(36, 85, 239,0.1)",
  },
  {
    color: "rgba(76, 175, 80, 1)",
    background: "rgba(76, 175, 80, 0.1)",
  },
];
